/**
 * @module MainPreloader
 */

import Component from '../components/base/Component';
import '../styles/main-preloader.css';

/**
 * Прелоадер.
 */

export default class MainPreloader extends Component {
    static className = 'preloader';

    static DEFAULT_TIME = 1000;

    init(options = {}) {
        super.init(options);

        window.addEventListener('load', () => {
            setTimeout(MainPreloader.fadeOut);
        });
    }

    static fadeOut(time) {
        if (time === undefined) {
            time = MainPreloader.DEFAULT_TIME;
        }

        const el = document.querySelector('.preloader__preload');
        const spinner = document.querySelector('.preloader__spinner');

        const interhellopreloader = setInterval(() => {
            el.style.opacity -= 0.05;

            if (el.style.opacity <= 0.05) {
                clearInterval(interhellopreloader);
                el.style.display = 'none';
                spinner.style.display = 'none';
            }
        }, 16);

        el.style.opacity = 1;
    }

    static show() {
        const el = document.querySelector('.preloader__preload');
        const spinner = document.querySelector('.preloader__spinner');

        el.style.opacity = 1;
        spinner.style.opacity = 1;
        el.style.display = 'block';
        spinner.style.display = 'block';
    }
}

MainPreloader.create();
